<template>
    <div class="partials search shadow" id="searchComponent" :class="{ loading: loading }">
        <form method="get" :action="formUrl" id="searchForm" @submit.prevent="onSubmit">
            <div
                class="country"
                :class="{ collapsed: !countrySelectorOpen }"
                id="countryButton"
                @click="toggleCountrySelector"
            >
                <div class="title">Land:</div>
                <div class="selected active" id="countrySelected">
                    <div v-if="selectedCountry">{{ selectedCountry.title }}</div>
                    <div v-else>Alle land</div>
                </div>
                <div
                    class="dropdown"
                    @click.stop="
                        () => {
                            /* Prevent clicks on the dropdown to bubble up and toggle the dropdown */
                        }
                    "
                >
                    <div class="dropdown-content inner-shadow">
                        <div class="headline">
                            <a
                                href="javascript:"
                                :class="{ active: !selectedCountry }"
                                id="countryReset"
                                @click="selectedCountry = null"
                                >Alle land</a
                            >
                        </div>
                        <div class="line">&nbsp;</div>
                        <div class="countries" id="countries">
                            <div
                                class="item"
                                :class="{ active: isCountrySelected(country) }"
                                v-for="country in countries"
                            >
                                <a href="javascript:" @click.prevent="setSelectedCountry(country)">
                                    {{ country.title }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="split">
                <div
                    class="departure"
                    :class="{ collapsed: !dateSelectorOpen }"
                    id="departureButton"
                    @click="toggleDateSelector"
                >
                    <div class="title">Avreisedato:</div>
                    <div class="selected active">
                        <div class="active" id="departureAll">
                            {{ displayDate }}
                        </div>
                    </div>
                    <div
                        class="dropdown"
                        @click.stop="
                            () => {
                                /* Prevent clicks on the dropdown to bubble up and toggle the dropdown */
                            }
                        "
                    >
                        <div class="dropdown-content inner-shadow">
                            <div class="splitter">
                                <div class="label">
                                    <button
                                        type="button"
                                        class="button"
                                        :class="{ active: !selectedYear }"
                                        id="departureYearReset"
                                        @click="selectedYear = null"
                                    >
                                        Alle år
                                    </button>
                                </div>
                                <div class="years" id="years">
                                    <button
                                        type="button"
                                        class="button year"
                                        :class="{
                                            active: isYearSelected(date.year),
                                            disabled: date.disabled,
                                        }"
                                        :disabled="date.disabled"
                                        v-for="date in dates"
                                        @click.prevent="setSelectedYear(date)"
                                    >
                                        {{ date.year }}
                                    </button>
                                </div>
                            </div>
                            <div class="splitter">
                                <div class="label">
                                    <button
                                        type="button"
                                        class="button"
                                        id="departureDateReset"
                                        :class="{ active: !selectedMonth }"
                                        @click="selectedMonth = null"
                                    >
                                        Alle datoer
                                    </button>
                                </div>
                                <div class="months" id="months" v-if="selectedYear">
                                    <button
                                        type="button"
                                        class="button month"
                                        @click="setSelectedMonth(month)"
                                        :class="{
                                            active: isMonthSelected(month),
                                            disabled: month.disabled,
                                        }"
                                        :disabled="month.disabled"
                                        v-for="month in selectedYear.months"
                                    >
                                        {{ month.name }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="airport"
                    :class="{ collapsed: !airportSelectorOpen }"
                    id="airportButton"
                    @click="toggleAirportSelector"
                >
                    <div class="title">Avreiseflyplass:</div>
                    <div class="selected active" id="airportSelected" v-if="!selectedAirport">
                        Alle flyplassene
                    </div>
                    <div class="selected active" id="airportSelected" v-else>
                        {{ selectedAirport.display }}
                    </div>
                    <div
                        class="dropdown"
                        @click.stop="
                            () => {
                                /* Prevent clicks on the dropdown to bubble up and toggle the dropdown */
                            }
                        "
                    >
                        <div class="dropdown-content inner-shadow">
                            <div class="headline">
                                <a
                                    href="javascript:"
                                    :class="{ active: !selectedAirport }"
                                    @click="selectedAirport = null"
                                    id="airportReset"
                                    >Alle avreiseflyplasser</a
                                >
                            </div>
                            <div class="line">&nbsp;</div>
                            <div class="terminals" id="terminals">
                                <div
                                    class="item"
                                    v-for="airport in airports"
                                    :class="{
                                        active: isAirportSelected(airport),
                                        disabled: airport.disabled,
                                    }"
                                >
                                    <a
                                        href="javascript:"
                                        @click.prevent="setSelectedAirport(airport)"
                                        ><span>{{ airport.title }}</span> {{ airport.place }}</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button type="submit" class="button button-submit" id="searchFormSubmit">
                <img src="/assets/icons/icon-search-white.svg" alt="icon-search" /> Søk
            </button>
        </form>
    </div>
</template>

<style>
    #search-bar {
        margin-top: 10px;
    }
</style>

<script>
    import axios from 'axios'
    import ClickOutside from 'vue-click-outside'

    export default {
        directives: {
            ClickOutside,
        },
        data() {
            return {
                loading: false,

                // Toggles
                countrySelectorOpen: false,
                airportSelectorOpen: false,
                dateSelectorOpen: false,

                // Keep track of selected state
                selectedCountry: null,
                selectedAirport: null,
                selectedYear: null,
                selectedMonth: null,

                countries: [],
                dates: [],
                airports: [],
            }
        },
        created() {
            this.fetchOptions()
            ;['selectedCountry', 'selectedYear', 'selectedMonth', 'selectedAirport'].forEach((v) =>
                this.$watch(v, this.fetchOptions)
            )

            // Collapse windows when clicking outside
            window.addEventListener('click', (e) => {
                if (e.target === this.$el || this.$el.contains(e.target)) {
                    return
                } else {
                    this.countrySelectorOpen = false
                    this.airportSelectorOpen = false
                    this.dateSelectorOpen = false
                }
            })
        },
        methods: {
            fetchOptions() {
                this.loading = true
                axios
                    .get('/actions/booking-module/booking/search-fields', {
                        params: {
                            countryTagId: this.selectedCountry
                                ? this.selectedCountry.screenbookingTag
                                : null,
                            airportTagId: this.selectedAirport
                                ? this.selectedAirport.screenbookingTag
                                : null,
                            month: this.selectedMonth ? this.selectedMonth.month : null,
                            year: this.selectedYear ? this.selectedYear.year : null,
                        },
                    })
                    .then((response) => {
                        this.loading = false
                        this.countries = response.data.countries
                        this.dates = response.data.dates
                        this.airports = response.data.airports
                    })
            },
            setSelectedCountry(country) {
                this.selectedCountry = country
            },
            setSelectedYear(year) {
                this.selectedYear = year
            },
            setSelectedMonth(month) {
                this.selectedMonth = month
            },
            setSelectedAirport(airport) {
                this.selectedAirport = airport
            },
            isAirportSelected(airport) {
                if (this.selectedAirport) {
                    return this.selectedAirport.id === airport.id
                }

                return false
            },
            isCountrySelected(country) {
                if (this.selectedCountry) {
                    return this.selectedCountry.id === country.id
                }

                return false
            },
            isMonthSelected(month) {
                if (this.selectedMonth) {
                    return this.selectedMonth.month === month.month
                }

                return false
            },
            isYearSelected(year) {
                if (this.selectedYear) {
                    return this.selectedYear.year === year
                }

                return false
            },
            parseMonth(month) {
                return month <= 9 ? `0${month}` : month
            },
            toggleCountrySelector() {
                if (this.countrySelectorOpen) {
                    this.countrySelectorOpen = false
                } else {
                    this.countrySelectorOpen = true
                    this.airportSelectorOpen = false
                    this.dateSelectorOpen = false
                }
            },
            toggleAirportSelector() {
                if (this.airportSelectorOpen) {
                    this.airportSelectorOpen = false
                } else {
                    this.countrySelectorOpen = false
                    this.airportSelectorOpen = true
                    this.dateSelectorOpen = false
                }
            },
            toggleDateSelector() {
                if (this.dateSelectorOpen) {
                    this.dateSelectorOpen = false
                } else {
                    this.countrySelectorOpen = false
                    this.airportSelectorOpen = false
                    this.dateSelectorOpen = true
                }
            },
            onSubmit() {
                let params = new URLSearchParams()

                if (this.selectedYear && this.selectedMonth) {
                    params.set(
                        'months[]',
                        `${this.selectedYear.year}-${this.parseMonth(this.selectedMonth.month)}`
                    )
                }

                if (this.selectedAirport) {
                    params.set('airports[]', this.selectedAirport.title)
                }

                location.href = `${this.formUrl}?${params.toString()}`
            },
        },
        computed: {
            formUrl() {
                return this.selectedCountry ? `/${this.selectedCountry.slug}` : '/reisekalender'
            },
            displayDate() {
                if (!this.selectedMonth && !this.selectedYear) {
                    return 'Alle datoer'
                }

                // Only have year
                if (!this.selectedMonth && this.selectedYear) {
                    return this.selectedYear.year
                }

                // Only have month
                if (this.selectedMonth && !this.selectedYear) {
                    return this.selectedMonth.name
                }

                // Have both
                return `${this.selectedMonth.name}, ${this.selectedYear.year}`
            },
        },
        watch: {
            selectedYear(newVal) {
                // If the year is reset, we should also reset the month.
                if (newVal == null) {
                    this.selectedMonth = null
                }
            },
        },
    }
</script>
